import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "@/axios/axios";
import libs from "./utils/libs";
import 'lib-flexible/flexible'
import components from './components' // icon
import vanTitle from './components/vanTitle/index.vue'
import vantEmpty from './components/vantEmpty/index.vue'
import Vant from 'vant'
import 'vant/lib/index.css' // 全局引入样式
import eventBus from './utils/eventBus'
// import jweixinModule from "jweixin-module"
// import $ from 'jquery'

//注入 vconsole
import VConsole from 'vconsole'

const app = createApp(App);
app.use(Vant).use(store).use(router).component('vanTitle', vanTitle).component('vantEmpty', vantEmpty).mount('#app');
app.use(axios)
app.use(libs)
app.use(components)
app.use(eventBus)

if(process.env.NODE_ENV != 'production'){
    const vconsole = new VConsole()
    app.use(vconsole)
}

app.config.isCustomElement = tag => tag === 'wx-open-launch-weapp'
